export const apiPath = {
  allAssetChanges: '/pool/asset-changes',
  allUsers: '/user/allUsers',
  application: '/fund-registration/application',
  assetChange: (poolId: string) => `/pool/${poolId}/asset-changes`,
  assetChangeKyc: (poolAddress: string, requestId: string) => `/pool/${poolAddress}/asset-changes/${requestId}/kyc`,
  assetsChanges: (poolAddress: string) => `/pool/${poolAddress}/asset-changes`,
  clientVerification: '/user/verification',
  connect: (investorAddress: string) => `/auth/connect/${investorAddress}`,
  fee: '/fee',
  feeSummary: '/fee/summary',
  fund: '/fund',
  fundDeployChain: '/fund-registration/deploy-chain',
  fundEmployee: (id: string) => `/fund-employee/${id}/employee`,
  getProfile: '/user/profile',
  info: '/info',
  investorsPortfolio: (investorAddress: string) => `/user/portfolio/${investorAddress}`,
  leaderboard: '/points/leaderboard',
  login: '/auth/login',
  logout: '/auth/logout',
  pool: '/pool',
  poolOperator: (poolAddress: string) => `/pool/${poolAddress}/operator`,
  protocol: (protocol: string) => `/protocol/${protocol}`,
  publicFile: '/storage/public',
  referrals: '/referrals',
  startKyc: '/user/kyc/start',
  statusKyc: '/user/kyc/status',
  token: '/dictionary/token',
  tokenEdit: (tokenId: string) => `/dictionary/token/${tokenId}`,
  unlimitSignedUrl: '/unlimit/createUrl',
  waitList: '/fund/waitlist',
}
